import React from "react";

const ARTISAN_IMG =
  "https://static.prod-images.emergentagent.com/jobs/6eda8702-546d-4ee1-94a6-0616cf049749/images/171fbccfa21bc4be9cab308a01555a91175b3099181494cd03358db7b3e87902.png";

export default function APropos() {
  return (
    <section
      id="apropos"
      data-testid="apropos-section"
      className="bg-[#FCFAF6] py-16 md:py-32"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={ARTISAN_IMG}
                alt="Artisan horloger au travail"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <p className="text-[10px] uppercase tracking-[0.4em] text-accent mb-6">
              À propos
            </p>
            <h2 className="font-serif font-light text-[#001226] text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight">
              Une maison,
              <br />
              <span className="italic">un savoir-faire.</span>
            </h2>

            <div className="mt-10 space-y-6 text-[#1E2A40] font-light leading-relaxed max-w-lg">
              <p>
                Depuis le cœur de Lausanne,{" "}
                <em className="text-[#001226] not-italic font-medium">Adjugé-Vendu</em> cultive une
                exigence absolue : présenter des garde-temps authentifiés,
                restaurés avec soin, et accompagnés d'un service à la hauteur de
                leur prestige.
              </p>
              <p>
                Notre maître horloger, formé aux ateliers de la Vallée de Joux,
                expertise chaque pièce avant son arrivée en vitrine.
                Authenticité, provenance, état mécanique — rien n'est laissé au
                hasard.
              </p>
              <p className="text-[#5C6373]">
                Plus de 1'200 transactions sécurisées · Membre de la Fédération
                Suisse de l'Horlogerie d'Occasion · Garantie 24 mois sur toutes
                nos pièces neuves.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4 max-w-md">
              <div className="border-t border-accent pt-4">
                <p className="font-serif text-3xl text-[#001226]">15</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#5C6373] mt-1">
                  Ans d'expertise
                </p>
              </div>
              <div className="border-t border-accent pt-4">
                <p className="font-serif text-3xl text-[#001226]">1'200+</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#5C6373] mt-1">
                  Clients satisfaits
                </p>
              </div>
              <div className="border-t border-accent pt-4">
                <p className="font-serif text-3xl text-[#001226]">24h</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-[#5C6373] mt-1">
                  Délai estimation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
